import { useMutation, useQuery } from '@tanstack/react-query';
import { handleResponse, patch, post, put, get } from './base.service';
import { handleError as appHandleError } from '@/utils/errorHandler';
import { API_ENDPOINTS } from '@/constants';
import type { ApiResponse } from './types';
import {
  ServiceListResponse,
  ServiceDetails
} from '@/constants/Interfaces/CommonInterfaces';

export const useGetServiceListQuery = (payload: string) =>
  useQuery<ServiceListResponse>({
    queryFn: async () => {
      const response = await get<ServiceListResponse>(
        `${API_ENDPOINTS.SERVICES}?${payload}`
      );
      return handleResponse(response);
    },
    refetchOnWindowFocus: false,
    queryKey: ['service-list', payload]
  });

export const useCreateServiceMutation = () =>
  useMutation<ApiResponse, Error, Record<string, unknown>>({
    mutationFn: (payload: Record<string, unknown>) => {
      return post(`${API_ENDPOINTS.SERVICES}`, payload);
    },
    onSuccess: handleResponse,
    onError: error => appHandleError(error)
  });

export const useUpdateServiceMutation = () =>
  useMutation<ApiResponse, Error, Record<string, unknown>>({
    mutationFn: (payload: Record<string, unknown>) => {
      return put(`${API_ENDPOINTS.SERVICES}/${payload.id}`, payload);
    },
    onSuccess: handleResponse,
    onError: error => appHandleError(error)
  });

export const useGetServiceDetailsQuery = (serviceId: string) =>
  useQuery<ServiceDetails>({
    queryFn: async () => {
      const response = await get<ServiceDetails>(
        `${API_ENDPOINTS.SERVICES}/${serviceId}`
      );
      return handleResponse(response);
    },
    queryKey: ['service-details', serviceId],
    enabled: !!serviceId,
    refetchOnWindowFocus: false
  });

export const useUpdateServiceStatusMutation = () =>
  useMutation<ApiResponse, Error, number>({
    mutationFn: (serviceId: number) => {
      return patch(`${API_ENDPOINTS.SERVICES}/${serviceId}`);
    },
    onSuccess: handleResponse,
    onError: error => appHandleError(error)
  });
